export const queryParamsArrayBuilder = (key = "", listArray = []) => {
  if (!key || !listArray.length) return "";

  return listArray.map((listItem) => `${key}[]=${listItem}`).join("&");
};
